import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { getLocations, getLocationDetail } from "./locationAPI";
const initialState = {
  list: undefined,
  detail: undefined,
  status: "idle",
  error: undefined,
};

export const getLocationsAsync = createAsyncThunk(
  "location",
  async (params, thunkAPI) => {
    try {
      const response = await getLocations(params);
      // The value we return becomes the `fulfilled` action payload
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const getLocationDetailAsync = createAsyncThunk(
  "locationDetail",
  async (id, thunkAPI) => {
    try {
      const response = await getLocationDetail(id);
      // The value we return becomes the `fulfilled` action payload
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const locationSlice = createSlice({
  name: "locations",
  initialState,
  reducers: {
    setIdleStatus: (state) => {
      state.status = "idle";
    },
    clearNewsDetail: (state) => {
      state.detail = undefined;
    },
    clearNews: (state) => {
      state.list = undefined;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(getLocationsAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getLocationsAsync.fulfilled, (state, action) => {
        state.list = action.payload.data;
        state.status = "idle";
        state.error = undefined;
      })
      .addCase(getLocationsAsync.rejected, (state, action) => {
        state.status = "idle";
        if (action?.error?.name !== "AbortError") {
          message.error("Lấy dữ liệu thất bại!");
          state.error = {
            payload: action.payload,
            title: "getNews",
          };
        }
      })
      .addCase(getLocationDetailAsync.pending, (state) => {
        state.status = "detail_loading";
      })
      .addCase(getLocationDetailAsync.fulfilled, (state, action) => {
        state.detail = action.payload.data;
        state.status = "idle";
        state.error = undefined;
      })
      .addCase(getLocationDetailAsync.rejected, (state, action) => {
        state.status = "idle";
        if (action?.error?.name !== "AbortError") {
          message.error("Lấy dữ liệu thất bại!");
          state.error = {
            payload: action.payload,
            title: "getNews",
          };
        }
      });
  },
});
export const selectLocations = (state) => state.locations.list;
export const selectLocationDetail = (state) => state.locations.detail;
export const locationStatus = (state) => state.locations.status;
export const locationError = (state) => state.locations.error;

export const { clearNewsDetail, clearNews, setIdleStatus } =
  locationSlice.actions;

export default locationSlice.reducer;
